import { useSelector } from 'react-redux';
import { WalletState } from '.';
import { RootState } from '..';

export const useGetWalletManager = (): WalletState =>
  useSelector((state: RootState) => {
    return state.WalletManager;
  });
